import i18n from '@/locale/index'

export default [
  {
    path: '/advertisingPopup',
    name: 'advertisingPopup',
    component: () => import('../../views/advertisingPopup/index.vue'),
    meta: {
      title: i18n.global.t('points.c5')
    }
  }
]
